import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ProjectService, WmHttpService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class IssuesService {
  private TARGET: string = "Issues";
  private API_META: any = {
    getServicesList: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/projectinspect/services/list",
      method: "GET"
    },
    getIssueLocationsByService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/projectinspect/services/:serviceID/list",
      method: "GET"
    },
    getIssuesByIssueLocation: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/projectinspect/services/:serviceID/pages/:pageName/report",
      method: "GET"
    }
  };
  public isEnabled: boolean;
  public activeTab: string;
  isAPIIssuesTabOpened: boolean;
  isFirstChecked:boolean;

  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.isEnabled = false;
  }

  getServicesList() {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'getServicesList',
      pathParams: {
        projectID: this.projectService.getProjectId()
      },
      spinnerInfo: {
        showSpinner: false
      }
    }) as Promise<any>);
  }

  getIssueLocationsByService(serviceId: string) {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'getIssueLocationsByService',
      pathParams: {
        projectID : this.projectService.getProjectId(),
        serviceID : serviceId
      },
      spinnerInfo: {
        showSpinner: false
      }
    }) as Promise<any>);
  }
  getIssuesByIssueLocation(serviceId: string, issueLocation: string) {
    return (this.wmHttpService.execute({
      target  : this.TARGET,
      action  : 'getIssuesByIssueLocation',
      pathParams: {
        projectID : this.projectService.getProjectId(),
        serviceID : serviceId,
        pageName  : issueLocation
      },
      spinnerInfo: {
        showSpinner: false
      }
    }) as Promise<any>);
  }
}
